import { useParams } from "react-router-dom";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";

import ProxyContent from "./ProxyContent";
import BuilderTabs from "../../Layouts/BuilderTabs";
import Monitor from "./Monitor";

const ProxyRoutes = () => {
  const params = useParams();
  return (
    <div className="application_container">
      <AppLeftSideBar type={params.orgId ? "app" : "org"} />
      <ProxyRouteEditor />
    </div>
  );
};

const ProxyRouteEditor = () => {
  const tabs = [
    {
      label: "proxy Routes",
      content: <ProxyContent />
    },
    {
      label: "Monitor",
      content: <Monitor />
    }
  ];

  return (
    <div className="page_section overflow_hidden">
      <BuilderTabs
        tabs={tabs}
        tabsClass="h_100 w_fit"
        contentStyle={{ height: "calc(100% - 48px)", padding: "20px", overflow: "auto" }}
      />
    </div>
  );
};

export default ProxyRoutes;
